import type React from 'react'
import { useFormContext } from 'react-hook-form'

export const ReviewStep: React.FC = () => {
  const { watch } = useFormContext()
  const formData = watch()

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Review Your Information</h3>
      <div className="space-y-2">
        <p>
          <strong>First Name:</strong> {formData.first_name}
        </p>
        <p>
          <strong>Last Name:</strong> {formData.last_name}
        </p>
        <p>
          <strong>Email:</strong> {formData.email}
        </p>
        <p>
          <strong>Phone Number:</strong> {formData.phone || 'Not provided'}
        </p>
      </div>
      <p className="text-sm text-gray-500">
        Please review your information before submitting.
      </p>
    </div>
  )
}
